package net.bothosting.docs.pages.hosting_in_bot_hosting_net

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initCreate_a_serverPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("hosting_in_bot_hosting_net/create_a_server.md", FrontMatterElement.Builder { addScalar("icon", "layer-plus"); }))
}

@Page("/hosting_in_bot_hosting_net/create-a-server")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Create_a_serverPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("create-a-server") }) {
        org.jetbrains.compose.web.dom.Text("Create a Server")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("before-you-start") }) {
        org.jetbrains.compose.web.dom.Text("Before you start")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Make sure you have created an account - ")
            com.varabyte.kobweb.silk.components.navigation.Link("create-an_account.md") {
                org.jetbrains.compose.web.dom.Text("Create an Account")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("create-a-server-2") }) {
        org.jetbrains.compose.web.dom.Text("Create a Server")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Select ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Create Server")
        }
        org.jetbrains.compose.web.dom.Text(" in the sidebar. You will see a page where you can enter your server requirements.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You will first be asked for a name and language. The name helps you identify the server if you have multiple servers. The language is the programming language your bot was coded in. You must select the correct language so the server is compatible with your bot.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Multiple users confuse Java with Node.js. JavaScript and Java are completely different languages.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Click ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Next")
        }
        org.jetbrains.compose.web.dom.Text(" once you have filled in these details.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (2).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You will then be asked to select a plan. Each plan comes with different server specifications. Depending on your bot's complexity, the intensity of its tasks, and the number of servers it is in, you will need to select a suitable plan. You can always change your plan later.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can view the price of the plans, this is how many coins you will have to pay either every week or every month. Below you can find an image of how it looks like, you can find a list of available plans and cost of them in coins/money ")
        com.varabyte.kobweb.silk.components.navigation.Link("../faqs_and_info/available-server_plans.md") {
            org.jetbrains.compose.web.dom.Text("here")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (3).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You will then be prompted to select your billing cycle. This is how often you will be charged coins. Your options are weekly or monthly. For most people, weekly billing is more flexible. Others may prefer to be billed once a month.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Choose whichever billing cycle you prefer.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (4).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Finally, confirm the server creation. You can also choose a paid subscription instead of using coins.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (5).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Once you confirm creation, your server will be created and the installation process will begin.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("possible-problems") }) {
        org.jetbrains.compose.web.dom.Text("Possible Problems")
    }
    org.jetbrains.compose.web.dom.Table {
        org.jetbrains.compose.web.dom.Thead {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Issue")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Reason")
                }
            }
        }
        org.jetbrains.compose.web.dom.Tbody {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("You do not have enough coins to afford this plan!")
                    }
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("You selected a plan that requires more coins than the amount you currently have in your Bot-hosting account.")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("There is not currently enough capacity to deploy your server. Please try again later or purchase a coin package with premium node!")
                    }
                }
                org.jetbrains.compose.web.dom.Td {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("p", attrs = {}) {
                        org.jetbrains.compose.web.dom.Text("Check out ")
                        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("data-mention", "");attr("href", "../faqs_and_info/issues-creating-server-free-users.md")}) {
                            org.jetbrains.compose.web.dom.Text("issues-creating-server-free-users.md")
                        }
                        org.jetbrains.compose.web.dom.Text(".")
                        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
                        org.jetbrains.compose.web.dom.Text("Some people might confuse this error with the one above but they are different.")
                    }
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("what-s-next") }) {
        org.jetbrains.compose.web.dom.Text("What's next?")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("/hosting_in_bot_hosting_net/set-up-a-server") {
            org.jetbrains.compose.web.dom.Text("Set Up a Server")
        }
        org.jetbrains.compose.web.dom.Text(" - Configure your server and upload your files.")
    }
}
